<template>
    <div class="account">
        <div class="fun_btns">
            <button
                type="button"
                @click="type = '个人信息'"
                :class="{ actived: type === '个人信息' }"
            >
                <span class="tab_mark">个</span>
                <span>
                    <strong>个人信息</strong>
                    <small>维护头像、姓名与联系方式</small>
                </span>
            </button>
            <button
                type="button"
                @click="type = '学校账号'"
                :class="{ actived: type === '学校账号' }"
                v-if="isManage"
            >
                <span class="tab_mark">校</span>
                <span>
                    <strong>学校账号</strong>
                    <small>查看和管理机构教师账号</small>
                </span>
            </button>
        </div>

        <div v-if="type === '个人信息'" class="person">
            <div class="profile_header">
                <div class="avatar_name_part">
                    <div
                        class="avatar_image"
                        :style="
                            (memberInfo.avatar
                                ? memberInfo.avatar
                                : 'avatar/default.png') | imgFormat(true)
                        "
                    >
                        <el-upload
                            class="upload-demo"
                            action=""
                            :headers="myHeaders"
                            :on-change="handleChange"
                            :before-upload="beforeUploadFile"
                            accept=".jpg,.jpeg,.png,.JPG,.JPEG,"
                            :show-file-list="false"
                            multiple
                            :limit="1"
                            :file-list="fileList"
                            name="file"
                            :http-request="uploadURL"
                        >
                            <div class="upload">更换头像</div>
                        </el-upload>
                    </div>
                </div>
                <div class="profile_summary">
                    <span class="profile_label">个人资料</span>
                    <div class="profile_name">
                        <strong v-if="!editMode">{{ memberInfo.nickName || '未设置姓名' }}</strong>
                        <el-input
                            v-model="nickName"
                            style="width: 220px"
                            @change="changeNickname"
                            v-else
                        />
                        <button
                            type="button"
                            class="edit_name"
                            @click="
                                editMode = !editMode;
                                nickName = memberInfo.nickName;
                            "
                        >
                            <i class="iconfont icon-xiugai" />
                            {{ editMode ? '取消' : '修改姓名' }}
                        </button>
                    </div>
                    <p>支持 JPG、JPEG、PNG 格式，图片大小不超过 2 MB。</p>
                </div>
            </div>
            <div class="profile_details">
                <div class="detail_item">
                    <span class="detail_label">手机号码</span>
                    <strong>{{ phoneNumber || '暂未绑定' }}</strong>
                    <span class="detail_hint">用于账号登录与安全验证</span>
                    <button type="button" class="detail_action" @click="bandPhone">
                        修改手机号
                    </button>
                </div>
                <div class="detail_item">
                    <span class="detail_label">所属机构</span>
                    <strong>{{ memberInfo.organizationName || '暂未加入机构' }}</strong>
                    <span class="detail_hint">当前账号所在的教学机构</span>
                </div>
                <div class="detail_item">
                    <span class="detail_label">登录密码</span>
                    <strong>{{ phoneNumber ? '手机号密码登录已启用' : '绑定手机号后可用' }}</strong>
                    <span class="detail_hint">定期修改密码可提升账号安全</span>
                    <button
                        type="button"
                        class="detail_action"
                        :disabled="!phoneNumber"
                        @click="openPasswordDialog"
                    >
                        修改密码
                    </button>
                </div>
            </div>
        </div>
        <div v-else class="school_accounts">
            <div class="school_summary">
                <div>
                    <h2>学校教师账号</h2>
                    <p>查询教师、审核新成员并维护账号状态。</p>
                </div>
                <span>{{ teacherList.length }} 位教师</span>
            </div>
            <div class="search_part ls_flexalign_center">
                <el-input v-model="params.name" placeholder="请输入教师名称" />
                <el-button type="primary" @click="getTeacherList">
                    查询
                </el-button>
                <div class="ls_flex_1"></div>
                <el-button type="success" @click="getCode">添加教师</el-button>
            </div>

            <el-table
                :data="teacherList"
                empty-text="暂无教师账号"
                :header-cell-style="{ background: '#FAFAFA' }"
                style="width: 100%"
            >
                <el-table-column label="姓名">
                    <template slot-scope="scope">
                        <span style="margin-right: 5px">
                            {{ scope.row.name }}
                        </span>

                        <el-tag type="danger" v-if="scope.row.isAdmin === 1">
                            管理员
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="联系方式">
                    <template slot-scope="scope">
                        {{ scope.row.phone || '--' }}
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        {{ scope.row.status === 2 ? '未审核' : '已审核' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div class="opt_part">
                            <template
                                v-if="
                                    scope.row.isAdmin === 0 &&
                                    scope.row.status === 0
                                "
                            >
                                <!-- <span @click="setStatus(scope.row.id, 1)">设为管理员</span> -->
                                <span @click="setStatus(scope.row.id, 2)">
                                    注销
                                </span>
                            </template>
                            <template v-if="scope.row.status === 2">
                                <span @click="exam(scope.row.id, 1)">通过</span>
                                <span @click="exam(scope.row.id, 2)">拒绝</span>
                            </template>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <changePhone ref="changePhone"></changePhone>
        <el-dialog
            title="修改登录密码"
            :visible.sync="showPasswordDialog"
            width="460px"
            :close-on-click-modal="false"
            @closed="resetPasswordForm"
        >
            <div class="password_dialog_tip">
                新密码需为 8-32 位，并同时包含字母和数字。
            </div>
            <el-form label-position="top">
                <el-form-item label="原密码">
                    <el-input
                        v-model="passwordForm.oldPassword"
                        type="password"
                        show-password
                        maxlength="32"
                        autocomplete="current-password"
                        placeholder="请输入原密码"
                    />
                </el-form-item>
                <el-form-item label="新密码">
                    <el-input
                        v-model="passwordForm.newPassword"
                        type="password"
                        show-password
                        maxlength="32"
                        autocomplete="new-password"
                        placeholder="请输入新密码"
                    />
                </el-form-item>
                <el-form-item label="确认新密码">
                    <el-input
                        v-model="passwordForm.confirmPassword"
                        type="password"
                        show-password
                        maxlength="32"
                        autocomplete="new-password"
                        placeholder="请再次输入新密码"
                        @keyup.enter.native="changePassword"
                    />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showPasswordDialog = false">取消</el-button>
                <el-button type="primary" :loading="passwordSaving" @click="changePassword">
                    确认修改
                </el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="新增教师"
            :visible.sync="showCode"
            width="410px"
            :close-on-click-modal="false"
        >
            <div class="poster" v-if="showCode">
                <div id="qrcode"></div>
                <div style="text-align: center" v-if="btnShow">
                    <el-button type="success" @click="download">
                        下载海报
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import html2canvas from 'html2canvas';
import changePhone from './components/changePhone.vue';
export default {
    watch: {
        type(val) {
            if (val === '学校账号') {
                this.getTeacherList();
            }
        },
    },
    components: {
        changePhone,
    },
    data() {
        return {
            btnShow: true,
            showCode: false,
            teacherList: [],
            params: {
                name: '',
            },
            type: '个人信息',
            fileList: [],
            ossData: {},
            upCount: 0,
            editMode: false,
            editPMode: false,
            nickName: '',
            professionId: '',
            showPasswordDialog: false,
            passwordSaving: false,
            passwordForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
        };
    },
    computed: {
        phoneNumber() {
            return this.$store.state.info.memberInfo.phone
                ? this.$store.state.info.memberInfo.phone.replace(
                      /(\d{3})\d{4}(\d{1})/,
                      '$1****$2'
                  )
                : '';
        },
        memberInfo() {
            // debugger;
            return this.$store.state.info.memberInfo;
        },
        myHeaders() {
            let token = localStorage.getItem('access_token');
            let value = {
                Authorization: token,
                uploadType: 'avatar',
            };
            return value;
        },
    },
    methods: {
        //审核
        exam(id, approveStatus) {
            this.$ajax
                .post('user/organization/admin/teacher/approve', {
                    id,
                    approveStatus,
                })
                .then(res => {
                    this.$message.success('审核成功');
                    this.getTeacherList();
                });
        },
        //下载
        download() {
            this.btnShow = false;
            this.$nextTick(() => {
                let shareContent = document.getElementsByClassName('poster')[0];
                const width = shareContent.offsetWidth;
                const height = shareContent.offsetHeight;
                let scale = 1;
                var opts = {
                    windowHeight: height,
                    windowWidth: width,
                    scale: scale,
                    scrollX: 0,
                    scrollY: 0,
                    y: 0,
                    backgroundColor: 'transparent', //背景图片透明
                    allowTaint: true, //跨域
                    useCORS: true, //跨域
                };
                html2canvas(shareContent, opts).then(canvas => {
                    let oImg = new Image();
                    oImg = canvas.toDataURL('image/png'); // 导出图片
                    var oA = document.createElement('a');
                    oA.download = '招生海报'; // 设置下载的文件名，默认是'下载'
                    oA.href = oImg;
                    document.body.appendChild(oA);
                    oA.click();
                    oA.remove();
                    this.btnShow = true;
                });
            });
        },
        //获取二维码
        getCode() {
            let url = '';
            this.$ajax.post('/user/teacher/getShareCode', {}).then(result => {
                url = result.data;
                this.showCode = true;
                this.$nextTick(() => {
                    new QRCode('qrcode', {
                        width: 115, // 设置宽度，单位像素
                        height: 115, // 设置高度，单位像素
                        text: url, // 设置二维码内容或跳转地址
                    });
                });
            });
        },
        //设置状态
        setStatus(id, type) {
            if (type === 1) {
                this.$confirm(
                    '管理员将可以拥有查看/新增教师的权限',
                    '是否将该教师设置为管理员？',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }
                ).then(() => {
                    this.$ajax
                        .post('/user/organization/admin/teacher/setAdmin', {
                            id,
                        })
                        .then(res => {
                            this.$message.success('设置成功');
                            setTimeout(() => {
                                window.location.reload();
                            }, 500);
                        });
                });
            } else {
                this.$confirm('注销操作不可撤回', '是否将该教师注销？', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$ajax
                        .post('/user/organization/admin/teacher/delete', { id })
                        .then(res => {
                            this.$message.success('注销成功');
                            this.getTeacherList();
                        });
                });
            }
        },
        //获取教师列表
        getTeacherList() {
            this.$ajax
                .post('/user/organization/admin/teacher/getList', this.params)
                .then(res => {
                    this.teacherList = res.list;
                });
        },
        bandPhone() {
            console.log(this.memberInfo);
            this.$refs.changePhone.show(this.memberInfo);
        },
        openPasswordDialog() {
            if (!this.phoneNumber) {
                this.$message.warning('请先绑定手机号');
                return;
            }
            this.showPasswordDialog = true;
        },
        resetPasswordForm() {
            this.passwordForm = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
            };
            this.passwordSaving = false;
        },
        changePassword() {
            const { oldPassword, newPassword, confirmPassword } = this.passwordForm;
            if (!oldPassword || !newPassword || !confirmPassword) {
                this.$message.warning('请完整填写密码信息');
                return;
            }
            if (!/^(?=.*[A-Za-z])(?=.*\d).{8,32}$/.test(newPassword)) {
                this.$message.warning('新密码需为8-32位，并同时包含字母和数字');
                return;
            }
            if (newPassword !== confirmPassword) {
                this.$message.warning('两次输入的新密码不一致');
                return;
            }
            if (this.passwordSaving) return;

            this.passwordSaving = true;
            this.$ajax.post('/user/password', this.passwordForm).then(() => {
                this.$message.success('密码修改成功');
                this.showPasswordDialog = false;
            }).finally(() => {
                this.passwordSaving = false;
            });
        },
        //更换职业
        changeProfession() {
            this.$ajax
                .post('/user/user/edit', {
                    profession: this.professionId,
                })
                .then(res => {
                    if (res.code == 200) {
                        this.$message.success('修改成功');
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    } else {
                        this.$message.warning(res.msg);
                    }
                });
        },
        //更换昵称
        changeNickname() {
            this.$ajax
                .post('/user/user/edit', {
                    name: this.nickName,
                })
                .then(res => {
                    if (res.code == 200) {
                        this.$message.success('修改成功');
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    } else {
                        this.$message.warning(res.msg);
                    }
                });
        },
        // 更改头像
        changeAvatar(url) {
            this.$ajax.post('/user/user/edit', { avatar: url }).then(res => {
                if (res.code == 200) {
                    this.$message.success('修改成功');
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }
            });
        },
        uploadURL(file, fileList) {
            this.uploadOss(file);
        },
        getOssKey() {
            return this.$ajax.post('user/oss/getKey?pathName=avatar');
        },
        uploadOss(file) {
            var filename = this.ossData.fileName;
            var formData = new FormData(); //注意formData里append添加的键的大小写
            formData.append(
                'key',
                this.ossData.path +
                    filename +
                    file.file.type.replace('image/', '.')
            ); //存储在oss的文件路径
            formData.append('OSSAccessKeyId', this.ossData.accessid); //accessKeyId
            formData.append('policy', this.ossData.policy); //policy
            formData.append('Signature', this.ossData.signature); //签名//如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
            formData.append('file', file.file);
            formData.append('success_action_status', 200); //成功后返回的操作码

            var url = this.ossData.host;
            var fileUrl =
                this.ossData.path +
                filename +
                file.file.type.replace('image/', '.');
            this.$axios
                .post(url, formData)
                .then(res => {
                    this.upCount = 0;
                    this.changeAvatar(fileUrl);
                })
                .catch(async error => {
                    this.upCount++;
                    if (this.upCount >= 3) {
                        return;
                    }
                    this.upCount++;
                    let ossData = await this.getOssKey();
                    this.ossData = ossData.data;
                    this.uploadOss(file);
                });
        },
        handleChange(file) {
            if (file.response) {
                if (file.response.code == 200) {
                    // debugger;
                    // this.$message.success("上传成功");
                    this.changeAvatar(file.response.msg);
                } else {
                    this.$message.error(file.response.msg);
                }
            }
        },
        beforeUploadFile(file) {
            let testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
            let size = file.size / 1024 / 1024;

            if (!testmsg) {
                this.$message.warning({
                    message: '错误格式提示 ： 图片格式不正确',
                });
                return false;
            }
            if (size > 2) {
                this.$message.warning({
                    message: '图片不可超过2M',
                });
                return false;
            }
        },
    },
    async mounted() {
        let ossData = await this.getOssKey();
        this.ossData = ossData.data;
    },
};
</script>
<style>
.el-form-item:hover i {
    display: inline-block !important;
}

.poster .el-button {
    background: #1d8f5f;
    border-color: #1d8f5f;
    width: 326px;
}
</style>
<style lang="scss" scoped>
.account {
    padding: 0;
}

.fun_btns {
    display: inline-grid;
    grid-template-columns: repeat(2, minmax(240px, 1fr));
    gap: 8px;
    margin-bottom: 18px;
    padding: 7px;
    border: 1px solid #e5ece7;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 10px 28px rgba(41, 76, 56, .05);

    > button {
        display: flex;
        align-items: center;
        gap: 12px;
        min-height: 58px;
        padding: 9px 16px;
        border: 0;
        border-radius: 12px;
        color: #5d6962;
        background: transparent;
        text-align: left;
        cursor: pointer;
        transition: all .2s ease;

        &:hover {
            color: #21965b;
            background: #f1faf5;
        }

        > span:last-child {
            display: flex;
            flex-direction: column;
            min-width: 0;
        }

        strong {
            font-size: 14px;
            line-height: 1.5;
        }

        small {
            margin-top: 2px;
            color: #93a098;
            font-size: 12px;
        }
    }

    .actived {
        color: #fff;
        background: #21965b;
        box-shadow: 0 8px 18px rgba(33, 150, 91, .2);

        .tab_mark {
            color: #21965b;
            background: #fff;
        }

        small {
            color: rgba(255, 255, 255, .75);
        }
    }

    .tab_mark {
        display: inline-flex;
        flex: 0 0 34px;
        align-items: center;
        justify-content: center;
        width: 34px;
        height: 34px;
        border-radius: 11px;
        color: #21965b;
        background: #eaf8f0;
        font-size: 13px;
        font-weight: 700;
    }
}

.person {
    overflow: hidden;
    border: 1px solid #e5ece7;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 12px 30px rgba(41, 76, 56, .06);

    .profile_header {
        display: flex;
        align-items: center;
        gap: 26px;
        padding: 30px;
        border-bottom: 1px solid #edf2ee;
        background: linear-gradient(125deg, #f0fbf5 0%, #f8fcfa 55%, #eef5ff 100%);
    }

    .profile_summary {
        min-width: 0;

        .profile_label {
            display: inline-flex;
            align-items: center;
            height: 26px;
            padding: 0 10px;
            border-radius: 999px;
            color: #21965b;
            background: rgba(255, 255, 255, .86);
            font-size: 12px;
            font-weight: 650;
        }

        p {
            margin: 9px 0 0;
            color: #859289;
            font-size: 13px;
        }
    }

    .profile_name {
        display: flex;
        align-items: center;
        gap: 14px;
        margin-top: 10px;

        > strong {
            color: #17231c;
            font-size: 24px;
            font-weight: 680;
        }
    }

    .edit_name,
    .detail_action {
        padding: 0;
        border: 0;
        color: #21965b;
        background: transparent;
        font-size: 13px;
        cursor: pointer;
    }

    .edit_name i {
        margin-right: 3px;
        font-size: 14px;
    }
}

.profile_details {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    padding: 24px 30px 30px;

    .detail_item {
        position: relative;
        display: flex;
        flex-direction: column;
        min-height: 112px;
        padding: 19px 20px;
        border: 1px solid #e7eee9;
        border-radius: 15px;
        background: #fbfdfc;
        box-sizing: border-box;

        .detail_label {
            color: #88958c;
            font-size: 12px;
        }

        strong {
            margin-top: 8px;
            color: #26322b;
            font-size: 16px;
            font-weight: 650;
        }

        .detail_hint {
            margin-top: 5px;
            color: #a0aaa4;
            font-size: 12px;
        }

        .detail_action {
            position: absolute;
            top: 20px;
            right: 20px;

            &:disabled {
                color: #aab4ae;
                cursor: not-allowed;
            }
        }
    }
}

.password_dialog_tip {
    margin-bottom: 18px;
    padding: 11px 13px;
    border-radius: 10px;
    color: #66756c;
    background: #f1faf5;
    font-size: 12px;
    line-height: 1.6;
}

::v-deep .el-dialog .el-form-item {
    margin-bottom: 16px;
}

::v-deep .el-dialog .el-form-item__label {
    padding: 0 0 6px;
    color: #4f5d54;
    font-size: 13px;
    font-weight: 650;
    line-height: 1.5;
}

.avatar_name_part {
    flex: 0 0 auto;

    .avatar_image {
        width: 126px;
        height: 126px;
        overflow: hidden;
        border: 5px solid rgba(255, 255, 255, .95);
        border-radius: 50%;
        background-position: center;
        background-size: cover;
        box-shadow: 0 12px 30px rgba(40, 86, 59, .14);
    }

    .upload {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 126px;
        height: 38px;
        margin-top: 88px;
        color: #fff;
        background: rgba(20, 35, 27, .68);
        font-size: 12px;
        opacity: 0;
        transition: opacity .2s ease;
    }

    .avatar_image:hover .upload {
        opacity: 1;
    }
}

.school_accounts {
    .school_summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        padding: 20px 22px;
        border: 1px solid #e5ece7;
        border-radius: 18px;
        background: linear-gradient(120deg, #f0fbf5, #fff);
        box-shadow: 0 10px 28px rgba(41, 76, 56, .05);

        h2 {
            margin: 0;
            color: #1c2821;
            font-size: 18px;
            font-weight: 680;
        }

        p {
            margin: 5px 0 0;
            color: #87938b;
            font-size: 13px;
        }

        > span {
            padding: 7px 12px;
            border-radius: 999px;
            color: #21965b;
            background: #eaf8f0;
            font-size: 12px;
            font-weight: 650;
        }
    }

    .search_part {
        margin: 0 0 16px;
    }

    ::v-deep .el-table {
        overflow: hidden;
        border-radius: 18px;
    }
}

#qrcode {
    position: absolute;
    top: 265px;
    left: 27px;
    width: 115px;
    height: 115px;
}

.poster {
    position: relative;
    width: 370px;
    height: 538px;
    padding-top: 432px;
    background-image: url('~@/assets/imgs/teacher_poster.png');
    background-size: cover;
    box-sizing: border-box;
}

.search_part {
    > *:first-child {
        width: 240px;
    }
}

@media (max-width: 760px) {
    .fun_btns {
        display: grid;
        grid-template-columns: 1fr;
        width: 100%;
        box-sizing: border-box;
    }

    .person .profile_header {
        align-items: flex-start;
        flex-direction: column;
        padding: 22px;
    }

    .profile_details {
        grid-template-columns: 1fr;
        padding: 18px 22px 22px;
    }

    .school_accounts .school_summary {
        align-items: flex-start;
        flex-direction: column;
        gap: 14px;
    }

    .search_part > *:first-child {
        width: 100%;
    }
}

@media (min-width: 761px) and (max-width: 1180px) {
    .profile_details {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
</style>
